import React, { useState } from 'react';

import cn from 'classnames';

let timer;

const DropdownMenu = ({ triggerButtonRender, children, binding, onClose, dropdownClassName}) => {
  const [openDownMenu, setOpenDownMenu] = useState(false);

  const handleOpenMenu = () => {
    setOpenDownMenu(!openDownMenu);
  };

  const enterDownMenu = () => {
    clearTimeout(timer);
    setOpenDownMenu(true);
  };

  const leaveDownMenu = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setOpenDownMenu(false);

      if (onClose) onClose();
    }, 350);
  };

  return (
    <div className="dropdown-menu__wrapper">
      <button className={cn('dashboard__block__button ', { 'active-button': openDownMenu })} onClick={handleOpenMenu}>
        {triggerButtonRender(openDownMenu)}
      </button>
      {openDownMenu && (
        <ul
          className={cn(
            'dropdown-menu-list',
              dropdownClassName,
            { 'active-menu': openDownMenu },
            {
              binding_top: binding === 'top',
              binding_bottom: binding === 'bottom',
            }
          )}
          onMouseEnter={enterDownMenu}
          onMouseLeave={leaveDownMenu}
        >
          {children}
        </ul>
      )}
    </div>
  );
};

export default DropdownMenu;
